module.exports = __webpack_public_path__ + "img/wap_daren_en1.1d58c274.jpg";